import { PayloadAction } from '@reduxjs/toolkit';
import { RegistrationSliceState } from '../state';

/**
 * Address type definition
 */
export interface AddressType {
  addressType: string;
  street?: string;
  street2?: string;
  city?: string;
  state?: string;
  zip?: string;
  isPreferred?: boolean;
}

/**
 * Add a new address to the registration
 */
export const addAddress = (
  state: RegistrationSliceState,
  action: PayloadAction<AddressType>
) => {
  if (state.currentRegistration) {
    if (!state.currentRegistration.addresses) {
      state.currentRegistration.addresses = [];
    }
    state.currentRegistration.addresses.push(action.payload);
    state.isEdited = true;
  }
};

/**
 * Update an existing address at a specific index
 */
export const updateAddress = (
  state: RegistrationSliceState,
  action: PayloadAction<{ index: number; address: AddressType }>
) => {
  if (state.currentRegistration?.addresses && state.currentRegistration.addresses[action.payload.index]) {
    state.currentRegistration.addresses[action.payload.index] = action.payload.address;
    state.isEdited = true;
  }
};

/**
 * Remove an address at a specific index (renamed from deleteAddress for consistency)
 */
export const removeAddress = (
  state: RegistrationSliceState,
  action: PayloadAction<number>
) => {
  if (state.currentRegistration?.addresses) {
    state.currentRegistration.addresses.splice(action.payload, 1);
    state.isEdited = true;
  }
};

/**
 * Delete an address at a specific index (alias for removeAddress, maintains backward compatibility)
 */
export const deleteAddress = (
  state: RegistrationSliceState,
  action: PayloadAction<number>
) => {
  removeAddress(state, action);
};
